



import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";

/* =========================================================
   COMMON HELPERS
========================================================= */

const money = (value) => Number(value || 0).toFixed(2);

const getItemName = (item) =>
  item?.item_name ||
  item?.name ||
  item?.itemName ||
  "-";

const getQty = (item) =>
  item?.qty ?? item?.quant ?? 0;

const getUnitPrice = (item) =>
  item?.price_per_unit ??
  item?.pur_price ??
  item?.price ??
  0;

const getTaxText = (item) => {
  if (item?.tax_name) return item.tax_name;
  if (item?.tax_rate !== undefined && item?.tax_rate !== null) {
    return `${item.tax_rate}%`;
  }
  return "-";
};

const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  if (Number.isNaN(d.getTime())) {
    return date;
  }

  return d.toLocaleDateString("en-GB");
};

const getApiBaseUrl = () => {
  const envUrl =
    typeof process !== "undefined"
      ? process.env.REACT_APP_API_URL
      : "";

  return String(envUrl || "").replace(/\/$/, "");
};

const getSignatureUrl = (clientData) => {
  if (!clientData?.sign) return "";

  return `https://api.dectwinbilling.com/dUploads/${encodeURIComponent(
    String(clientData.sign).trim()
  )}`;
};

/* =========================================================
   COMMON TABLE STYLES
========================================================= */

const thStyle = {
  border: "1px solid #000",
  padding: "5px",
  textAlign: "center",
  verticalAlign: "middle",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
};

const tdStyle = {
  border: "1px solid #000",
  padding: "5px",
  verticalAlign: "middle",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
};


/* =========================================================
   SUMMARY
========================================================= */

const SummaryRow = ({
  label,
  value,
  bold = false,
}) => (
  <div
    className="invoice-summary-row"
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "10px",
      fontWeight: bold ? "700" : "400",
      marginBottom: "3px",
      lineHeight: "1.35",
    }}
  >
    <span
      style={{
        flex: "1 1 auto",
        minWidth: 0,
      }}
    >
      {label}
    </span>

    <span
      style={{
        flex: "0 0 auto",
        textAlign: "right",
        whiteSpace: "nowrap",
      }}
    >
      {money(value)}
    </span>
  </div>
);


/* =========================================================
   SIGNATURE
========================================================= */

// const SignatureBlock = ({
//   invoice,
//   clientData,
// }) => {
//   const rawSignature =
//     clientData?.sign ||
//     clientData?.signature ||
//     clientData?.signatureImage ||
//     invoice?.sign ||
//     invoice?.signature ||
//     invoice?.signatureImage ||
//     "";

//   const signature = getSignatureUrl(rawSignature);
//   console.log(signature,'sig')

//   console.log(clientData.sign)

//   return (
//     <div
//       className="invoice-signature-wrapper"
//       style={{
//         width: "100%",
//         marginTop: "22px",
//         display: "flex",
//         justifyContent: "flex-end",
//         pageBreakInside: "avoid",
//         breakInside: "avoid",
//       }}
//     >
//       <div
//         className="invoice-signature"
//         style={{
//           width: "180px",
//           maxWidth: "100%",
//           textAlign: "center",
//           pageBreakInside: "avoid",
//           breakInside: "avoid",
//         }}
//       >
//         <div
//           className="invoice-signature-image-area"
//           style={{
//             height: "62px",
//             display: "flex",
//             alignItems: "flex-end",
//             justifyContent: "center",
//             overflow: "hidden",
//           }}
//         >
//           {signature ? (
//             <img
//               src={signature}
//               alt="Authorized Signature"
//               className="invoice-signature-image"
//               style={{
//                 display: "block",
//                 width: "150px",
//                 maxWidth: "100%",
//                 height: "55px",
//                 objectFit: "contain",
//                 objectPosition: "center bottom",
//               }}
//               onError={(e) => {
//                 e.currentTarget.style.display = "none";
//               }}
//             />
//           ) : null}
//         </div>

//         <div
//           style={{
//             borderTop: "1px solid #000",
//             paddingTop: "5px",
//             fontSize: "11px",
//             fontWeight: "600",
//             lineHeight: "1.2",
//             whiteSpace: "normal",
//           }}
//         >
//           Authorized Signature
//         </div>
//       </div>
//     </div>
//   );
// };


// const SignatureBlock = ({ invoice, clientData }) => {
//   const signature = clientData?.sign
//     ? `https://api.dectwinbilling.com/dUploads/${encodeURIComponent(
//         String(clientData.sign).trim()
//       )}`
//     : "";

//   return (
//     <div
//       style={{
//         width: "100%",
//         marginTop: "22px",
//         display: "flex",
//         justifyContent: "flex-end",
//       }}
//     >
//       <div
//         style={{
//           width: "180px",
//           textAlign: "center",
//         }}
//       >
//         <div
//           style={{
//             height: "70px",
//             display: "flex",
//             alignItems: "flex-end",
//             justifyContent: "center",
//           }}
//         >
//           {signature ? (
//             <img
//               src={signature}
//               alt="Authorized Signature"
//               style={{
//                 display: "block",
//                 width: "150px",
//                 height: "60px",
//                 objectFit: "contain",
//               }}
//               onLoad={() => {
//                 console.log(
//                   "SIGNATURE IMAGE LOADED:",
//                   signature
//                 );
//               }}
//               onError={(e) => {
//                 console.error(
//                   "SIGNATURE IMAGE FAILED:",
//                   signature
//                 );

//                 console.error(
//                   "Image element:",
//                   e.currentTarget
//                 );
//               }}
//             />
//           ) : (
//             <span>No signature</span>
//           )}
//         </div>

//         <div
//           style={{
//             borderTop: "1px solid #000",
//             paddingTop: "5px",
//             fontSize: "11px",
//             fontWeight: "600",
//           }}
//         >
//           Authorized Signature
//         </div>
//       </div>
//     </div>
//   );
// };



const SignatureBlock = ({ invoice, clientData }) => {
  const rawSignature =
    clientData?.sign ||
    clientData?.signature ||
    clientData?.signatureImage ||
    invoice?.sign ||
    invoice?.signature ||
    invoice?.signatureImage ||
    "";

  const signature = rawSignature
    ? (
        String(rawSignature).startsWith("http://") ||
        String(rawSignature).startsWith("https://") ||
        String(rawSignature).startsWith("data:image/")
      )
      ? String(rawSignature)
      : `https://api.dectwinbilling.com/dUploads/${encodeURIComponent(
          String(rawSignature).trim()
        )}`
    : "";

  return (
    <div
      className="invoice-signature-wrapper"
      style={{
        width: "100%",
        marginTop: "25px",
        display: "flex",
        justifyContent: "flex-end",
        pageBreakInside: "avoid",
        breakInside: "avoid",
      }}
    >
      <div
        className="invoice-signature"
        style={{
          width: "180px",
          textAlign: "center",
        }}
      >
        {/* SIGNATURE IMAGE */}
        <div
          style={{
            height: "60px",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
          }}
        >
          {signature && (
            <img
              src={signature}
              alt="Authorized Signature"
              style={{
                display: "block",
                width: "150px",
                height: "55px",
                objectFit: "contain",
              }}
            />
          )}
        </div>

        {/* SIGNATURE LINE */}
        <div
          style={{
            borderTop: "1px solid #000",
            paddingTop: "5px",
            fontSize: "11px",
            fontWeight: "600",
            whiteSpace: "nowrap",
          }}
        >
          Authorized Signature
        </div>
      </div>
    </div>
  );
};

/* =========================================================
   COMPANY INFO
========================================================= */

const CompanyInfo = ({
  clientData,
  centered = false,
  showEmail = true,
  showContact = true,
  showGstin = true,
}) => {
  const comContact =
    localStorage.getItem("company_contact");

  const comEmail =
    localStorage.getItem("company_email");

  const comGstin =
    localStorage.getItem("company_gstin");

  return (
    <div
      style={{
        textAlign: centered ? "center" : "left",
        minWidth: 0,
      }}
    >
      <strong
        style={{
          fontSize: "16px",
          overflowWrap: "anywhere",
        }}
      >
        {clientData?.business_name || "-"}
      </strong>

      {showContact && comContact == 1 && (
        <div style={{ overflowWrap: "anywhere" }}>
          Contact: {clientData?.mobile || "-"}
        </div>
      )}

      {showGstin && comGstin == 1 && (
        <div style={{ overflowWrap: "anywhere" }}>
          GSTIN: {clientData?.gst || "-"}
        </div>
      )}

      {showEmail && comEmail == 1 && (
        <div
          style={{
            fontWeight: "700",
            overflowWrap: "anywhere",
          }}
        >
          Email: {clientData?.email || "-"}
        </div>
      )}

      <div
        style={{
          overflowWrap: "anywhere",
          wordBreak: "break-word",
        }}
      >
        ADDRESS: {clientData?.address || "-"}
      </div>
    </div>
  );
};


/* =========================================================
   PAPER WRAPPER
========================================================= */

const InvoicePaper = ({
  children,
  format = "a4",
}) => {
  const isThermal = format === "thermal";

  return (
    <div
      className={`invoice-paper-shell ${
        isThermal
          ? "invoice-paper-shell-thermal"
          : "invoice-paper-shell-a4"
      }`}
      data-paper-format={format}
    >
      <div
        className={`invoice-paper ${
          isThermal
            ? "invoice-paper-thermal"
            : "invoice-paper-a4"
        }`}
      >
        {children}
      </div>
    </div>
  );
};




const RegularTheme1 = ({
  invoice,
  billTitle,
  clientData,
}) => {
  const items = invoice.items || [];

  const grossAmount =
    billTitle === "PURCHASE INVOICE"
      ? items.reduce(
          (total, item) =>
            total + Number(item.amount || 0),
          0
        )
      : Number(invoice.totalSP || 0);

  return (
    <InvoicePaper format="a4">
      <div className="invoice-content">

        {/* TITLE */}
        <div
          style={{
            textAlign: "center",
            fontWeight: "700",
            fontSize: "20px",
            marginBottom: "8px",
            overflowWrap: "anywhere",
          }}
        >
          {billTitle}
        </div>

        {/* COMPANY */}
        <div
          style={{
            border: "1px solid #000",
            padding: "6px",
          }}
        >
          <CompanyInfo
            clientData={clientData}
            centered={false}
          />
        </div>

        {/* BILL INFO */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            marginTop: "7px",
            marginBottom: "7px",
          }}
        >
          <div
            style={{
              minWidth: 0,
              paddingRight: "8px",
            }}
          >
            <strong>Billed To:</strong>

            <div>
              {invoice.cust_name || "-"}
            </div>

            <div
              style={{
                overflowWrap: "anywhere",
              }}
            >
              Address: {invoice.cust_address || "-"}
            </div>

            <div>
              Contact: {invoice.cust_number || "-"}
            </div>
          </div>

          <div
            style={{
              textAlign: "right",
              minWidth: 0,
              paddingLeft: "8px",
            }}
          >
            <div>
              <strong>Invoice Number:</strong>{" "}
              {invoice.invoiceNo}
            </div>

            <div>
              <strong>Invoice Date:</strong>{" "}
              {formatDate(
                invoice.date || invoice.dateTime
              )}
            </div>

            <div>
              <strong>Customer GST:</strong>{" "}
              {invoice.gstin || "-"}
            </div>
          </div>
        </div>

        {/* ITEMS */}
        <div className="invoice-table-container">
          <table
            className="invoice-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "12px",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#000",
                  color: "#fff",
                }}
              >
                <th
                  style={{
                    ...thStyle,
                    width: "31%",
                  }}
                >
                  Item Name
                </th>

                <th style={{ ...thStyle, width: "10%" }}>
                  Qty
                </th>

                <th style={{ ...thStyle, width: "16%" }}>
                  Unit Price
                </th>

                <th style={{ ...thStyle, width: "14%" }}>
                  Discount
                </th>

                <th style={{ ...thStyle, width: "12%" }}>
                  Tax
                </th>

                <th style={{ ...thStyle, width: "17%" }}>
                  Total
                </th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                  }}
                >
                  <td style={tdStyle}>
                    {getItemName(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {getQty(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(getUnitPrice(item))}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.discount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(
                      item.taxAmount ??
                        item.taxRate ??
                        0
                    )}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* TOTAL AREA */}
        <div
          className="invoice-two-column invoice-total-area"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            marginTop: "8px",
          }}
        >
          <div />

          <div
            style={{
              minWidth: 0,
            }}
          >
            <SummaryRow
              label="Gross Amount"
              value={grossAmount}
            />

            <SummaryRow
              label="Total Tax"
              value={invoice.totalTax}
            />

            <SummaryRow
              label="Total Discount"
              value={
                invoice.totalDis ??
                invoice.last_discount
              }
            />

            <SummaryRow
              label="Payable Amount"
              value={invoice.payable}
              bold
            />

            <SummaryRow
              label="Received"
              value={invoice.recieved}
            />

            <SummaryRow
              label="Due Amount"
              value={invoice.due}
              bold
            />
          </div>
        </div>

        {invoice.description && (
          <div
            style={{
              marginTop: "12px",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            <strong>Description:</strong>

            <div>
              {invoice.description}
            </div>
          </div>
        )}

        


      <SignatureBlock
          invoice={invoice}
          clientData={clientData}
        />
              </div>
    </InvoicePaper>
  );
};

const RegularTheme2 = ({
  invoice,
  billTitle,
  clientData,
}) => {
  const items = invoice.items || [];

  const grossAmount =
    billTitle === "PURCHASE INVOICE"
      ? items.reduce(
          (total, item) =>
            total + Number(item.amount || 0),
          0
        )
      : Number(invoice.totalSP || 0);

  return (
    <InvoicePaper format="a4">
      <div className="invoice-content">

        {/* HEADER */}
        <div
          style={{
            border: "1px solid #000",
            textAlign: "center",
            padding: "5px",
          }}
        >
          <div style={{ fontWeight: "700" }}>
            {billTitle}
          </div>

          <CompanyInfo
            clientData={clientData}
            centered
          />
        </div>

        {/* BILL INFORMATION */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            border: "1px solid #000",
            borderTop: "none",
          }}
        >
          <div
            style={{
              padding: "6px",
              borderRight: "1px solid #000",
              minWidth: 0,
            }}
          >
            <strong>Invoice Number:</strong>{" "}
            {invoice.invoiceNo}

            <br />

            <strong>Date:</strong>{" "}
            {formatDate(
              invoice.date ||
                invoice.dateTime
            )}
          </div>

          <div
            style={{
              padding: "6px",
              minWidth: 0,
            }}
          >
            <strong>Billed To:</strong>{" "}
            {invoice.cust_name || "-"}

            <br />

            Contact:{" "}
            {invoice.cust_number || "-"}

            <br />

            <div
              style={{
                overflowWrap: "anywhere",
              }}
            >
              Email:{" "}
              {clientData?.email || "-"}
            </div>

            <div
              style={{
                overflowWrap: "anywhere",
              }}
            >
              Customer Add:{" "}
              {invoice.cust_address || "-"}
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="invoice-table-container">
          <table
            className="invoice-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
              tableLayout: "fixed",
              fontSize: "12px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    ...thStyle,
                    width: "31%",
                  }}
                >
                  Item Name
                </th>

                <th style={{ ...thStyle, width: "10%" }}>
                  Qty
                </th>

                <th style={{ ...thStyle, width: "16%" }}>
                  Unit Price
                </th>

                <th style={{ ...thStyle, width: "14%" }}>
                  Discount
                </th>

                <th style={{ ...thStyle, width: "12%" }}>
                  Tax
                </th>

                <th style={{ ...thStyle, width: "17%" }}>
                  Total
                </th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                  }}
                >
                  <td style={tdStyle}>
                    {getItemName(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {getQty(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(getUnitPrice(item))}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.discount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(
                      item.taxAmount ??
                        item.taxRate ??
                        0
                    )}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* TOTALS */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            marginTop: "5px",
          }}
        >
          <div />

          <div>
            <SummaryRow
              label="Gross Amount"
              value={grossAmount}
            />

            <SummaryRow
              label="Total Tax"
              value={invoice.totalTax}
            />

            <SummaryRow
              label="Total Discount"
              value={
                invoice.totalDis ??
                invoice.last_discount
              }
            />

            <div
              style={{
                background: "#000",
                color: "#fff",
                padding: "6px",
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                fontWeight: "700",
              }}
            >
              <span>Payable Amount:</span>

              <span
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                {money(invoice.payable)}
              </span>
            </div>

            <SummaryRow
              label="Received"
              value={invoice.recieved}
            />

            <SummaryRow
              label="Due Amount"
              value={invoice.due}
              bold
            />

   
          </div>
        </div>
      </div>

               <SignatureBlock
              invoice={invoice}
              clientData={clientData}
            />
    </InvoicePaper>
  );
};



const RegularTheme3 = ({
  invoice,
  billTitle,
  clientData,
}) => {
  const items = invoice.items || [];

  const grossAmount =
    billTitle === "PURCHASE INVOICE"
      ? items.reduce(
          (total, item) =>
            total + Number(item.amount || 0),
          0
        )
      : Number(invoice.totalSP || 0);

  return (
    <InvoicePaper format="a4">
      <div className="invoice-content">

        {/* HEADER */}
        <div
          style={{
            border: "1px solid #000",
            textAlign: "center",
            padding: "6px",
          }}
        >
          <strong>{billTitle}</strong>

          <br />

          <CompanyInfo
            clientData={clientData}
            centered
          />
        </div>

        {/* CUSTOMER / INVOICE */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            border: "1px solid #000",
            borderTop: "none",
          }}
        >
          <div
            style={{
              padding: "6px",
              minWidth: 0,
            }}
          >
            <strong>Invoice Number:</strong>{" "}
            {invoice.invoiceNo}

            <br />

            <strong>Invoice Date:</strong>{" "}
            {formatDate(
              invoice.date ||
                invoice.dateTime
            )}

            <br />

            <strong>Customer GSTIN:</strong>{" "}
            {invoice.gstin || "-"}
          </div>

          <div
            style={{
              padding: "6px",
              borderLeft: "1px solid #000",
              minWidth: 0,
            }}
          >
            <strong>Billed To:</strong>{" "}
            {invoice.cust_name || "-"}

            <br />

            Contact:{" "}
            {invoice.cust_number || "-"}

            <br />

            <span
              style={{
                overflowWrap: "anywhere",
              }}
            >
              Address:{" "}
              {invoice.cust_address || "-"}
            </span>
          </div>
        </div>

        {/* ITEMS */}
        <div className="invoice-table-container">
          <table
            className="invoice-table invoice-table-small"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
              fontSize: "10px",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    ...thStyle,
                    width: "23%",
                  }}
                >
                  Item Name
                </th>

                <th style={{ ...thStyle, width: "7%" }}>
                  Qty
                </th>

                <th style={{ ...thStyle, width: "11%" }}>
                  Unit Price
                </th>

                <th style={{ ...thStyle, width: "10%" }}>
                  Discount
                </th>

                <th style={{ ...thStyle, width: "10%" }}>
                  CGST Rate
                </th>

                <th style={{ ...thStyle, width: "11%" }}>
                  CGST Amount
                </th>

                <th style={{ ...thStyle, width: "10%" }}>
                  SGST Rate
                </th>

                <th style={{ ...thStyle, width: "11%" }}>
                  SGST Amount
                </th>

                <th style={{ ...thStyle, width: "7%" }}>
                  Total
                </th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                  }}
                >
                  <td style={tdStyle}>
                    {getItemName(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {getQty(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(getUnitPrice(item))}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.discount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {item.cgst_rate || "-"}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.cgst_amount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {item.sgst_rate || "-"}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.sgst_amount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* TAX TOTAL */}
        <div
          className="invoice-tax-summary"
          style={{
            display: "grid",
            gridTemplateColumns:
              "1fr 1fr 1fr 1fr",
            border: "1px solid #000",
            borderTop: "none",
            padding: "6px",
            textAlign: "center",
          }}
        >
          <div>
            <strong>Total CGST</strong>
            <br />
            {money(invoice.cgst)}
          </div>

          <div>
            <strong>Total SGST</strong>
            <br />
            {money(invoice.sgst)}
          </div>

          <div>
            <strong>Total IGST</strong>
            <br />
            {money(invoice.igst)}
          </div>

          <div>
            <strong>Total Tax</strong>
            <br />
            {money(invoice.totalTax)}
          </div>
        </div>

        {/* TOTALS */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            border: "1px solid #000",
            borderTop: "none",
            padding: "7px",
          }}
        >
          <div />

          <div>
            <SummaryRow
              label="Gross Amount"
              value={grossAmount}
            />

            <SummaryRow
              label="Total Tax"
              value={invoice.totalTax}
            />

            <SummaryRow
              label="Total Discount"
              value={
                invoice.totalDis ??
                invoice.last_discount
              }
            />

            <SummaryRow
              label="Payable Amount"
              value={invoice.payable}
              bold
            />

            <SummaryRow
              label="Received"
              value={invoice.recieved}
            />

            <SummaryRow
              label="Due Amount"
              value={invoice.due}
              bold
            />
          </div>
        </div>

        {invoice.description && (
          <div
            style={{
              marginTop: "12px",
              overflowWrap: "anywhere",
            }}
          >
            <strong>Description:</strong>

            <div>
              {invoice.description}
            </div>
          </div>
        )}

        <SignatureBlock
          invoice={invoice}
          clientData={clientData}
        />
      </div>
    </InvoicePaper>
  );
};


const RegularTheme4 = ({
  invoice,
  billTitle,
  clientData,
}) => {
  const items = invoice.items || [];

  const grossAmount =
    billTitle === "PURCHASE INVOICE"
      ? items.reduce(
          (total, item) =>
            total + Number(item.amount || 0),
          0
        )
      : Number(invoice.totalSP || 0);

  return (
    <InvoicePaper format="a4">
      <div className="invoice-content">

        {/* HEADER */}
        <div
          className="invoice-header-flex"
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "15px",
            borderBottom: "3px double #aaa",
            paddingBottom: "8px",
          }}
        >
          <div
            style={{
              minWidth: 0,
              flex: "1 1 auto",
            }}
          >
            <strong
              style={{
                fontSize: "17px",
                overflowWrap: "anywhere",
              }}
            >
              {clientData?.business_name || "-"}
            </strong>

            {localStorage.getItem(
              "company_contact"
            ) == 1 && (
              <div>
                Contact:{" "}
                {clientData?.mobile || "-"}
              </div>
            )}

            {localStorage.getItem(
              "company_gstin"
            ) == 1 && (
              <div>
                GSTIN:{" "}
                {clientData?.gst || "-"}
              </div>
            )}

            {localStorage.getItem(
              "company_email"
            ) == 1 && (
              <div
                style={{
                  fontWeight: "700",
                  overflowWrap: "anywhere",
                }}
              >
                Email:{" "}
                {clientData?.email || "-"}
              </div>
            )}

            <div
              style={{
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              ADDRESS:{" "}
              {clientData?.address || "-"}
            </div>
          </div>

          <div
            style={{
              fontSize: "18px",
              fontWeight: "700",
              flex: "0 0 auto",
              textAlign: "right",
              overflowWrap: "anywhere",
            }}
          >
            {billTitle}
          </div>
        </div>

        {/* CUSTOMER */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            marginTop: "10px",
            marginBottom: "10px",
            borderBottom: "3px double #aaa",
            paddingBottom: "8px",
          }}
        >
          <div
            style={{
              minWidth: 0,
              paddingRight: "10px",
            }}
          >
            <strong>Billed To:</strong>

            <br />

            {invoice.cust_name || "-"}

            <br />

            Contact:{" "}
            {invoice.cust_number || "-"}

            <br />

            <span
              style={{
                overflowWrap: "anywhere",
              }}
            >
              Address:{" "}
              {invoice.cust_address || "-"}
            </span>
          </div>

          <div
            style={{
              textAlign: "right",
              minWidth: 0,
              paddingLeft: "10px",
            }}
          >
            <strong>Invoice Number:</strong>{" "}
            {invoice.invoiceNo}

            <br />

            <strong>Invoice Date:</strong>{" "}
            {formatDate(
              invoice.date ||
                invoice.dateTime
            )}

            <br />

            <strong>Customer GSTIN:</strong>{" "}
            {invoice.gstin || "-"}
          </div>
        </div>

        {/* ITEMS */}
        <div className="invoice-table-container">
          <table
            className="invoice-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "12px",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#000",
                  color: "#fff",
                }}
              >
                <th
                  style={{
                    ...thStyle,
                    width: "31%",
                  }}
                >
                  Item Name
                </th>

                <th style={{ ...thStyle, width: "10%" }}>
                  Qty
                </th>

                <th style={{ ...thStyle, width: "16%" }}>
                  Unit Price
                </th>

                <th style={{ ...thStyle, width: "14%" }}>
                  Discount
                </th>

                <th style={{ ...thStyle, width: "12%" }}>
                  Tax
                </th>

                <th style={{ ...thStyle, width: "17%" }}>
                  Total
                </th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                  }}
                >
                  <td style={tdStyle}>
                    {getItemName(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {getQty(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(getUnitPrice(item))}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.discount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {money(
                      item.taxAmount ??
                        item.taxRate ??
                        0
                    )}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* TOTALS */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            marginTop: "12px",
          }}
        >
          <div />

          <div>
            <SummaryRow
              label="Gross Amount"
              value={grossAmount}
            />

            <SummaryRow
              label="Total Tax"
              value={invoice.totalTax}
            />

            <SummaryRow
              label="Total Discount"
              value={
                invoice.totalDis ??
                invoice.last_discount
              }
            />

            <div
              style={{
                background: "#000",
                color: "#fff",
                padding: "6px",
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                fontWeight: "700",
              }}
            >
              <span>Total amount:</span>

              <span
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                {money(invoice.payable)}
              </span>
            </div>

            <SummaryRow
              label="Received"
              value={invoice.recieved}
            />

            <SummaryRow
              label="Due Amount"
              value={invoice.due}
              bold
            />
          </div>
        </div>

        {invoice.description && (
          <div
            style={{
              marginTop: "12px",
              overflowWrap: "anywhere",
            }}
          >
            <strong>Description:</strong>

            <br />

            {invoice.description}
          </div>
        )}

        <SignatureBlock
          invoice={invoice}
          clientData={clientData}
        />
      </div>
    </InvoicePaper>
  );
};



const DectwinIGSTTheme = ({
  invoice,
  billTitle,
  clientData,
}) => {
  const items = invoice.items || [];

  const grossAmount =
    billTitle === "PURCHASE INVOICE"
      ? items.reduce(
          (total, item) =>
            total + Number(item.amount || 0),
          0
        )
      : Number(invoice.totalSP || 0);

  return (
    <InvoicePaper format="a4">
      <div className="invoice-content">

        {/* HEADER */}
        <div
          style={{
            border: "1px solid #000",
            textAlign: "center",
            padding: "6px",
          }}
        >
          <div style={{ fontWeight: "700" }}>
            {billTitle}
          </div>

          <CompanyInfo
            clientData={clientData}
            centered
          />
        </div>

        {/* BILL INFO */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            border: "1px solid #000",
            borderTop: "none",
          }}
        >
          <div
            style={{
              padding: "6px",
              minWidth: 0,
            }}
          >
            <strong>Invoice Number:</strong>{" "}
            {invoice.invoiceNo}

            <br />

            <strong>Invoice Date:</strong>{" "}
            {formatDate(
              invoice.date ||
                invoice.dateTime
            )}

            <br />

            <strong>Customer GSTIN:</strong>{" "}
            {invoice.gstin || "-"}
          </div>

          <div
            style={{
              padding: "6px",
              borderLeft: "1px solid #000",
              minWidth: 0,
            }}
          >
            <strong>Billed To:</strong>{" "}
            {invoice.cust_name || "-"}

            <br />

            Contact:{" "}
            {invoice.cust_number || "-"}

            <br />

            <span
              style={{
                overflowWrap: "anywhere",
              }}
            >
              Address:{" "}
              {invoice.cust_address || "-"}
            </span>
          </div>
        </div>

        {/* ITEMS */}
        <div className="invoice-table-container">
          <table
            className="invoice-table invoice-table-small"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
              fontSize: "10px",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    ...thStyle,
                    width: "27%",
                  }}
                >
                  Item Name
                </th>

                <th style={{ ...thStyle, width: "8%" }}>
                  Qty
                </th>

                <th style={{ ...thStyle, width: "14%" }}>
                  Unit Price
                </th>

                <th style={{ ...thStyle, width: "12%" }}>
                  Discount
                </th>

                <th style={{ ...thStyle, width: "13%" }}>
                  IGST Rate
                </th>

                <th style={{ ...thStyle, width: "14%" }}>
                  IGST Amount
                </th>

                <th style={{ ...thStyle, width: "12%" }}>
                  Total
                </th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                  }}
                >
                  <td style={tdStyle}>
                    {getItemName(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {getQty(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(getUnitPrice(item))}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.discount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {getTaxText(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.igst_amount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* TAX */}
        <div
          className="invoice-tax-summary"
          style={{
            display: "grid",
            gridTemplateColumns:
              "1fr 1fr 1fr 1fr",
            border: "1px solid #000",
            borderTop: "none",
            padding: "6px",
            textAlign: "center",
          }}
        >
          <div>
            <strong>Total CGST</strong>
            <br />
            0.00
          </div>

          <div>
            <strong>Total SGST</strong>
            <br />
            0.00
          </div>

          <div>
            <strong>Total IGST</strong>
            <br />
            {money(invoice.igst)}
          </div>

          <div>
            <strong>Total Tax</strong>
            <br />
            {money(invoice.totalTax)}
          </div>
        </div>

        {/* TOTAL AREA */}
        <div
          className="invoice-two-column"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            border: "1px solid #000",
            borderTop: "none",
            padding: "8px",
          }}
        >
          <div />

          <div>
            <SummaryRow
              label="Gross Amount"
              value={grossAmount}
            />

            <SummaryRow
              label="Total Tax"
              value={invoice.totalTax}
            />

            <SummaryRow
              label="Total Discount"
              value={
                invoice.totalDis ??
                invoice.last_discount
              }
            />

            <SummaryRow
              label="Payable Amount"
              value={invoice.payable}
              bold
            />

            <SummaryRow
              label="Received"
              value={invoice.recieved}
            />

            <SummaryRow
              label="Due Amount"
              value={invoice.due}
              bold
            />
          </div>
        </div>

        {invoice.description && (
          <div
            style={{
              marginTop: "8px",
              overflowWrap: "anywhere",
            }}
          >
            <strong>Description:</strong>

            <br />

            {invoice.description}
          </div>
        )}

        <SignatureBlock
          invoice={invoice}
          clientData={clientData}
        />
      </div>
    </InvoicePaper>
  );
};



const ThermalTheme1 = ({
  invoice,
  billTitle,
  clientData,
}) => {
  const items = invoice.items || [];

  const grossAmount =
    billTitle === "PURCHASE INVOICE"
      ? items.reduce(
          (total, item) =>
            total + Number(item.amount || 0),
          0
        )
      : Number(invoice.totalSP || 0);

  return (
    <InvoicePaper format="thermal">
      <div className="invoice-content">

        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontWeight: "700",
            }}
          >
            {billTitle}
          </div>

          <div
            style={{
              fontSize: "18px",
              fontWeight: "700",
              overflowWrap: "anywhere",
            }}
          >
            {clientData?.business_name || "-"}
          </div>

          {localStorage.getItem(
            "company_contact"
          ) == 1 && (
            <div>
              Contact:{" "}
              {clientData?.mobile || "-"}
            </div>
          )}

          {localStorage.getItem(
            "company_gstin"
          ) == 1 && (
            <div>
              GSTIN:{" "}
              {clientData?.gst || "-"}
            </div>
          )}

          {localStorage.getItem(
            "company_email"
          ) == 1 && (
            <div
              style={{
                fontWeight: "700",
                overflowWrap: "anywhere",
              }}
            >
              Email:{" "}
              {clientData?.email || "-"}
            </div>
          )}

          <div
            style={{
              fontWeight: "700",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            {clientData?.address || "-"}
          </div>
        </div>

        {/* CUSTOMER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "8px",
            marginTop: "10px",
          }}
        >
          <div
            style={{
              minWidth: 0,
              flex: "1 1 50%",
            }}
          >
            <strong>
              {invoice.cust_name || "-"}
            </strong>

            <br />

            Mob. No:{" "}
            {invoice.cust_number || "-"}
          </div>

          <div
            style={{
              textAlign: "right",
              minWidth: 0,
              flex: "1 1 50%",
            }}
          >
            Date:{" "}
            {formatDate(
              invoice.date ||
                invoice.dateTime
            )}

            <br />

            Invoice No:{" "}
            {invoice.invoiceNo}
          </div>
        </div>

        {/* ITEMS */}
        <div
          className="invoice-table-container"
          style={{
            overflow: "visible",
          }}
        >
          <table
            className="invoice-table thermal-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "7px",
              tableLayout: "fixed",
              fontSize: "11px",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#f8cbbb",
                }}
              >
                <th
                  style={{
                    ...thStyle,
                    width: "32%",
                  }}
                >
                  Name
                </th>

                <th
                  style={{
                    ...thStyle,
                    width: "13%",
                  }}
                >
                  Qty
                </th>

                <th
                  style={{
                    ...thStyle,
                    width: "18%",
                  }}
                >
                  Rate
                </th>

                <th
                  style={{
                    ...thStyle,
                    width: "15%",
                  }}
                >
                  Dis
                </th>

                <th
                  style={{
                    ...thStyle,
                    width: "22%",
                  }}
                >
                  Amt
                </th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                  }}
                >
                  <td style={tdStyle}>
                    {getItemName(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                    }}
                  >
                    {getQty(item)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(getUnitPrice(item))}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.discount)}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: "right",
                    }}
                  >
                    {money(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* TOTALS */}
        <div
          style={{
            marginTop: "6px",
          }}
        >
          <SummaryRow
            label="Gross Amount:"
            value={grossAmount}
          />

          <SummaryRow
            label="Total Tax"
            value={invoice.totalTax}
          />

          <SummaryRow
            label="Total Dis:"
            value={
              invoice.totalDis ??
              invoice.last_discount
            }
            bold
          />

          <SummaryRow
            label="Payable Amount:"
            value={invoice.payable}
            bold
          />

          <SummaryRow
            label="Received:"
            value={invoice.recieved}
          />

          <SummaryRow
            label="Due Amount:"
            value={invoice.due}
          />
        </div>

        {invoice.description && (
          <div
            style={{
              marginTop: "8px",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            <strong>Description:</strong>

            <br />

            {invoice.description}
          </div>
        )}

        <SignatureBlock
          invoice={invoice}
          clientData={clientData}
        />

        <div
          style={{
            textAlign: "center",
            marginTop: "12px",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              fontWeight: "700",
            }}
          >
            THANKS FOR VISITING
          </div>

          <br />

          <strong>
            MADE WITH DECTWIN BILLING SOFTWARE
          </strong>
        </div>
      </div>
    </InvoicePaper>
  );
};



const ThermalTheme2 = ({
  invoice,
  clientData,
}) => {
  return (
    <InvoicePaper format="thermal">
      <div className="invoice-content">

        <div
          style={{
            textAlign: "center",
          }}
        >
          <strong>TAX INVOICE</strong>

          <br />

          <strong>
            {invoice.seller ||
              clientData?.business_name ||
              "TESTING ACCOUNT"}
          </strong>

          <br />

          {invoice.company_address ||
            clientData?.address ||
            "-"}

          <br />

          GSTIN:{" "}
          {invoice.company_gstin ||
            invoice.gstin ||
            clientData?.gst ||
            "-"}
        </div>

        <hr />

        <div>
          Customer:{" "}
          <strong>
            {invoice.cust_name || "-"}
          </strong>

          <br />

          Invoice: {invoice.invoiceNo}

          <br />

          Date:{" "}
          {formatDate(
            invoice.date ||
              invoice.dateTime
          )}
        </div>

        <hr />

        {(invoice.items || []).map(
          (item, index) => (
            <div
              key={index}
              style={{
                marginBottom: "5px",
                pageBreakInside: "avoid",
                breakInside: "avoid",
              }}
            >
              <strong
                style={{
                  overflowWrap: "anywhere",
                }}
              >
                {getItemName(item)}
              </strong>

              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  gap: "5px",
                }}
              >
                <span>
                  {getQty(item)} ×{" "}
                  {money(getUnitPrice(item))}
                </span>

                <span>
                  {money(item.amount)}
                </span>
              </div>
            </div>
          )
        )}

        <hr />

        <SummaryRow
          label="Total"
          value={invoice.payable}
          bold
        />

        <SummaryRow
          label="Received"
          value={invoice.recieved}
        />

        <SummaryRow
          label="Due"
          value={invoice.due}
          bold
        />

        <hr />

        <div
          style={{
            textAlign: "center",
          }}
        >
          Thank you for your business!
        </div>

        <SignatureBlock
          invoice={invoice}
          clientData={clientData}
        />
      </div>
    </InvoicePaper>
  );
};


/* =========================================================
   RESPONSIVE CSS
========================================================= */

const RESPONSIVE_CSS = `
  * {
    box-sizing: border-box;
  }

  html,
  body {
    margin: 0;
    padding: 0;
  }

  .invoice-preview-page {
    width: 100%;
    min-height: 100vh;
  }

  .invoice-preview-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }

  .invoice-preview-paper-area {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: visible;
    padding: 20px 0 40px;
  }

  .invoice-paper-shell {
    position: relative;
    flex: 0 0 auto;
  }

  /*
    A4 physical dimensions.
    The inner paper is ALWAYS 210mm wide.
    JS applies transform scale on small screens.
  */
  .invoice-paper-shell-a4 {
    width: 210mm;
    height: auto;
  }

  .invoice-paper-a4 {
    width: 210mm;
    min-height: 297mm;
    background: #fff;
    color: #000;
    transform-origin: top left;
  }

  /*
    Thermal paper.
    Keep actual 80mm width.
  */
  .invoice-paper-shell-thermal {
    width: 80mm;
    height: auto;
  }

  .invoice-paper-thermal {
    width: 80mm;
    min-height: 180mm;
    background: #fff;
    color: #000;
    transform-origin: top left;
  }

  .invoice-content {
    width: 100%;
    min-width: 0;
    overflow: visible;
  }

  .invoice-table-container {
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }

  .invoice-table {
    max-width: 100%;
  }

  .invoice-table th,
  .invoice-table td {
    max-width: 100%;
  }

  .invoice-table img {
    max-width: 100%;
  }

  /*
    Important:
    text must wrap rather than force the invoice wider.
  */
  .invoice-content,
  .invoice-content * {
    overflow-wrap: anywhere;
    word-break: normal;
  }

  .invoice-content table {
    word-break: normal;
  }

  .invoice-content td,
  .invoice-content th {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  /*
    Summary values should stay together.
  */
  .invoice-summary-row {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  /*
    Signature must never escape the paper.
  */
  .invoice-signature-wrapper {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .invoice-signature {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .invoice-signature-image {
    max-width: 100%;
  }

  /*
    Desktop preview.
  */
  @media (min-width: 769px) {
    .invoice-paper-shell-a4 {
      width: 210mm;
    }

    .invoice-paper-shell-thermal {
      width: 80mm;
    }
  }

  /*
    Tablet.
  */
  @media (max-width: 768px) {
    .invoice-preview-page {
      overflow-x: hidden;
    }

    .invoice-preview-container {
      width: 100%;
      padding-left: 10px;
      padding-right: 10px;
    }

    .invoice-preview-paper-area {
      width: 100%;
      overflow: hidden;
      justify-content: flex-start;
      padding-top: 10px;
    }

    .invoice-paper-shell {
      margin-left: auto;
      margin-right: auto;
    }

    /*
      The actual scale is set by JavaScript.
      Do not change the A4 paper dimensions here.
    */
    .invoice-paper-a4,
    .invoice-paper-thermal {
      margin: 0;
    }

    .invoice-two-column {
      grid-template-columns: 1fr 1fr !important;
    }

    .invoice-header-flex {
      gap: 10px !important;
    }
  }

  /*
    Phone.
  */
  @media (max-width: 480px) {
    .invoice-preview-container {
      padding-left: 6px;
      padding-right: 6px;
    }

    .invoice-preview-paper-area {
      padding-top: 5px;
      padding-bottom: 20px;
    }

    .invoice-two-column {
      grid-template-columns: 1fr 1fr !important;
    }

    .invoice-tax-summary {
      grid-template-columns: 1fr 1fr !important;
      row-gap: 6px;
    }

    .invoice-signature-wrapper {
      margin-top: 15px !important;
    }

    .invoice-signature {
      width: 150px !important;
    }

    .invoice-signature-image-area {
      height: 55px !important;
    }

    .invoice-signature-image {
      width: 130px !important;
      height: 50px !important;
    }
  }

  /*
    Very small phones.
  */
  @media (max-width: 360px) {
    .invoice-preview-container {
      padding-left: 3px;
      padding-right: 3px;
    }
  }

  /*
    PRINT
  */
  @media print {

    html,
    body {
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      width: auto !important;
      min-width: 0 !important;
      overflow: visible !important;
    }

    body * {
      visibility: hidden;
    }

    #bill-to-print,
    #bill-to-print * {
      visibility: visible;
    }

    #bill-to-print {
      position: static !important;
      width: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
    }

    .invoice-preview-paper-area {
      display: block !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: visible !important;
    }

    .invoice-paper-shell {
      margin: 0 !important;
      transform: none !important;
      overflow: visible !important;
    }

    .invoice-paper-a4 {
      width: 210mm !important;
      min-height: 297mm !important;
      transform: none !important;
      margin: 0 !important;
      padding: 12mm !important;
      overflow: visible !important;
    }

    .invoice-paper-thermal {
      width: 80mm !important;
      min-height: 180mm !important;
      transform: none !important;
      margin: 0 !important;
      padding: 4mm !important;
      overflow: visible !important;
    }

    .invoice-content {
      overflow: visible !important;
    }

    .invoice-table {
      width: 100% !important;
    }

    tr,
    td,
    th {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }

    .invoice-signature-wrapper,
    .invoice-signature {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }

    img {
      max-width: 100% !important;
    }
  }
`;


/* =========================================================
   MAIN COMPONENT
========================================================= */

const InvoicePreview = ({
  clientData,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const invoice = location.state?.invoice;
  const billTitle = location.state?.billTitle;

  const printRef = useRef(null);
  const paperAreaRef = useRef(null);

  const [billFormat, setBillFormat] =
    useState("regular1");

  const [paperScale, setPaperScale] =
    useState(1);

  const formats = useMemo(
    () => [
      {
        id: "regular1",
        name: "Regular Theme 1",
        type: "a4",
      },
      {
        id: "regular2",
        name: "Regular Theme 2",
        type: "a4",
      },
      {
        id: "regular3",
        name: "Regular Theme 3",
        type: "a4",
      },
      {
        id: "regular4",
        name: "Regular Theme 4",
        type: "a4",
      },
      {
        id: "dectwin",
        name: "Dectwin IGST Theme",
        type: "a4",
      },
      {
        id: "thermal1",
        name: "Thermal Theme 1",
        type: "thermal",
      },
      // {
      //   id: "thermal2",
      //   name: "Thermal Theme 2",
      //   type: "thermal",
      // },
    ],
    []
  );

  const selectedFormat = useMemo(
    () =>
      formats.find(
        (format) =>
          format.id === billFormat
      ) || formats[0],
    [billFormat, formats]
  );


  /* =======================================================
     RESPONSIVE PAPER SCALE
  ======================================================= */

  useEffect(() => {
    const calculateScale = () => {
      const area = paperAreaRef.current;

      if (!area) return;

      const isThermal =
        selectedFormat.type === "thermal";

      /*
        CSS physical dimensions converted approximately
        to pixels using browser CSS resolution.

        A4:
          210mm ≈ 793.7px

        Thermal:
          80mm ≈ 302.4px
      */
      const paperWidthPx = isThermal
        ? 302.36
        : 793.70;

      const availableWidth =
        area.clientWidth;

      if (!availableWidth) {
        setPaperScale(1);
        return;
      }

      /*
        Desktop:
        Do not scale down unless necessary.

        Mobile:
        Scale to fit available width.
      */
      const calculatedScale = Math.min(
        1,
        availableWidth / paperWidthPx
      );

      setPaperScale(
        Math.max(
          0.25,
          calculatedScale
        )
      );
    };

    calculateScale();

    window.addEventListener(
      "resize",
      calculateScale
    );

    /*
      ResizeObserver catches Bootstrap/container
      layout changes too.
    */
    let observer;

    if (
      typeof ResizeObserver !==
      "undefined" &&
      paperAreaRef.current
    ) {
      observer =
        new ResizeObserver(
          calculateScale
        );

      observer.observe(
        paperAreaRef.current
      );
    }

    return () => {
      window.removeEventListener(
        "resize",
        calculateScale
      );

      if (observer) {
        observer.disconnect();
      }
    };
  }, [selectedFormat.type]);


  /* =======================================================
     PRINT
  ======================================================= */

//   const handlePrint = () => {
//     const bill =
//       document.getElementById(
//         "bill-to-print"
//       );

//     if (!bill) {
//       alert("Bill not found");
//       return;
//     }

//     const printWindow =
//       window.open(
//         "",
//         "_blank",
//         "width=900,height=1100"
//       );

//     if (!printWindow) {
//       alert(
//         "Please allow popups for printing"
//       );
//       return;
//     }

//     const isThermal =
//       selectedFormat.type ===
//       "thermal";

//     const pageSize = isThermal
//       ? "80mm auto"
//       : "A4";

//     const pageMargin = "0";

//     printWindow.document.open();

//     printWindow.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <meta charset="UTF-8" />

//           <title>
//             ${invoice.invoiceNo || "Invoice"}
//           </title>

//       <style>

//   @page {
//     size: ${pageSize};
//     margin: 0;
//   }

//   * {
//     box-sizing: border-box !important;
//   }

//   html,
//   body {
//     margin: 0 !important;
//     padding: 0 !important;
//     background: #fff !important;
//   }

//   body {
//     width: ${
//       isThermal
//         ? "80mm"
//         : "210mm"
//     } !important;

//     overflow: visible !important;
//   }

//   #print-bill {
//     width: ${
//       isThermal
//         ? "80mm"
//         : "210mm"
//     } !important;

//     margin: 0 !important;
//     padding: 0 !important;

//     overflow: visible !important;
//   }

//   .invoice-paper-shell {
//     width: ${
//       isThermal
//         ? "80mm"
//         : "210mm"
//     } !important;

//     margin: 0 !important;
//     padding: 0 !important;

//     transform: none !important;
//     overflow: visible !important;
//   }

//   .invoice-paper-a4 {
//     width: 210mm !important;
//     min-height: 297mm !important;

//     margin: 0 !important;
//     padding: 12mm !important;

//     background: #fff !important;

//     transform: none !important;
//     overflow: visible !important;
//   }

//   .invoice-paper-thermal {
//     width: 80mm !important;
//     min-height: 180mm !important;

//     margin: 0 !important;
//     padding: 4mm !important;

//     background: #fff !important;

//     transform: none !important;
//     overflow: visible !important;
//   }

//   .invoice-content {
//     width: 100% !important;
//     overflow: visible !important;
//   }

//   .invoice-table {
//     width: 100% !important;
//     border-collapse: collapse !important;
//   }

//   th,
//   td {
//     overflow-wrap: anywhere !important;
//     word-break: break-word !important;
//   }

//   tr {
//     page-break-inside: avoid !important;
//     break-inside: avoid !important;
//   }

//   /* ================================
//      SIGNATURE POSITION
//      ================================ */

//   .invoice-signature-wrapper {
//     margin-top: 35px !important;
//     page-break-inside: avoid !important;
//     break-inside: avoid !important;
//   }

//   .invoice-signature {
//     transform: translateY(8px) !important;
//   }

//   img {
//     max-width: 100% !important;
//   }

//   ${
//     isThermal
//       ? `
//         .invoice-paper-thermal {
//           font-size: 12px !important;
//         }

//         .invoice-content {
//           width: 100% !important;
//         }

//         .invoice-signature-wrapper {
//           margin-top: 25px !important;
//         }

//         .invoice-signature {
//           transform: translateY(4px) !important;
//         }
//       `
//       : ""
//   }

// </style>
//         </head>

//         <body>

//           <div id="print-bill">
//             ${bill.innerHTML}
//           </div>

//         </body>
//       </html>
//     `);

//     printWindow.document.close();

//     /*
//       Wait for images to load before printing.
//     */
//     const printWhenReady = () => {
//       printWindow.focus();

//       setTimeout(() => {
//         printWindow.print();

//         /*
//           Do not close immediately on some browsers because
//           print dialog may still be opening.
//         */
//         setTimeout(() => {
//           printWindow.close();
//         }, 1000);
//       }, 300);
//     };

//     printWindow.onload = () => {
//       const images =
//         printWindow.document.images;

//       if (!images.length) {
//         printWhenReady();
//         return;
//       }

//       let loaded = 0;

//       const imageFinished = () => {
//         loaded++;

//         if (
//           loaded >= images.length
//         ) {
//           printWhenReady();
//         }
//       };

//       Array.from(images).forEach(
//         (img) => {
//           if (img.complete) {
//             imageFinished();
//           } else {
//             img.onload =
//               imageFinished;

//             img.onerror =
//               imageFinished;
//           }
//         }
//       );

//       /*
//         Safety timeout so a broken signature image
//         cannot prevent printing.
//       */
//       setTimeout(() => {
//         printWhenReady();
//       }, 2000);
//     };
//   };

const handlePrint = () => {
  const bill = document.getElementById("bill-to-print");

  if (!bill) {
    alert("Bill not found");
    return;
  }

  const printWindow = window.open(
    "",
    "_blank",
    "width=900,height=1100"
  );

  if (!printWindow) {
    alert("Please allow popups for printing");
    return;
  }

  const isThermal = selectedFormat.type === "thermal";

  const pageSize = isThermal ? "80mm auto" : "A4";

  printWindow.document.open();

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />

        <title>
          ${invoice.invoiceNo || "Invoice"}
        </title>

        <style>

          @page {
            size: ${pageSize};
            margin: 0;
          }

          * {
            box-sizing: border-box !important;
          }

          html,
          body {
            margin: 0 !important;
            padding: 0 !important;
            background: #fff !important;
          }

          body {
            width: ${
              isThermal
                ? "80mm"
                : "210mm"
            } !important;

            overflow: visible !important;
          }

          #print-bill {
            width: ${
              isThermal
                ? "80mm"
                : "210mm"
            } !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow: visible !important;
          }

          /* =================================
             PAPER
             ================================= */

          .invoice-paper-shell {
            width: ${
              isThermal
                ? "80mm"
                : "210mm"
            } !important;

            margin: 0 !important;
            padding: 0 !important;

            transform: none !important;
            overflow: visible !important;
          }

          .invoice-paper-a4 {
            width: 210mm !important;
            min-height: 297mm !important;

            margin: 0 !important;
            padding: 12mm !important;

            background: #fff !important;

            position: relative !important;

            transform: none !important;
            overflow: visible !important;
          }

          

          .invoice-paper-thermal {
            width: 80mm !important;
            min-height: 180mm !important;

            margin: 0 !important;
            padding: 4mm !important;

            background: #fff !important;

            transform: none !important;
            overflow: visible !important;
          }

          /* =================================
             CONTENT
             ================================= */

          .invoice-content {
            width: 100% !important;
            overflow: visible !important;
          }

          /* =================================
             TABLE
             ================================= */

          .invoice-table {
            width: 100% !important;
            border-collapse: collapse !important;
          }

          th,
          td {
            overflow-wrap: anywhere !important;
            word-break: break-word !important;
          }

          tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }

          /* =================================
             SIGNATURE
             DO NOT CHANGE POSITION
             ================================= */

          .invoice-signature-wrapper {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }

          .invoice-signature {
            transform: none !important;
          }

          /* =================================
             IMAGES
             ================================= */

          img {
            max-width: 100% !important;
          }

          /* =================================
             THERMAL ONLY
             ================================= */

          ${
            isThermal
              ? `
                .invoice-paper-thermal {
                  font-size: 12px !important;
                }

                .invoice-content {
                  width: 100% !important;
                }
              `
              : ""
          }

        </style>
      </head>

      <body>

        <div id="print-bill">
          ${bill.innerHTML}
        </div>

      </body>
    </html>
  `);

  printWindow.document.close();

  /*
    Wait for images to load before printing.
  */
  const printWhenReady = () => {
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();

      /*
        Give the browser time to open
        the print dialog before closing.
      */
      setTimeout(() => {
        printWindow.close();
      }, 1000);
    }, 300);
  };

  printWindow.onload = () => {
    const images = printWindow.document.images;

    if (!images.length) {
      printWhenReady();
      return;
    }

    let loaded = 0;

    const imageFinished = () => {
      loaded++;

      if (loaded >= images.length) {
        printWhenReady();
      }
    };

    Array.from(images).forEach((img) => {
      if (img.complete) {
        imageFinished();
      } else {
        img.onload = imageFinished;
        img.onerror = imageFinished;
      }
    });

    /*
      Safety timeout so a broken image
      cannot prevent printing.
    */
    setTimeout(() => {
      printWhenReady();
    }, 2000);
  };
};


  if (!invoice) {
    return (
      <div className="container mt-5 text-center">
        <h4>
          Invoice data not found
        </h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() =>
            navigate("/home")
          }
        >
          Go Back
        </button>
      </div>
    );
  }


  /* =======================================================
     BILL
  ======================================================= */

  const renderBill = () => {
    switch (billFormat) {
      case "regular1":
        return (
          <RegularTheme1
            invoice={invoice}
            billTitle={billTitle}
            clientData={clientData}
          />
        );

      case "regular2":
        return (
          <RegularTheme2
            invoice={invoice}
            billTitle={billTitle}
            clientData={clientData}
          />
        );

      case "regular3":
        return (
          <RegularTheme3
            invoice={invoice}
            billTitle={billTitle}
            clientData={clientData}
          />
        );

      case "regular4":
        return (
          <RegularTheme4
            invoice={invoice}
            billTitle={billTitle}
            clientData={clientData}
          />
        );

      case "dectwin":
        return (
          <DectwinIGSTTheme
            invoice={invoice}
            billTitle={billTitle}
            clientData={clientData}
          />
        );

      case "thermal1":
        return (
          <ThermalTheme1
            invoice={invoice}
            billTitle={billTitle}
            clientData={clientData}
          />
        );

      case "thermal2":
        return (
          <ThermalTheme2
            invoice={invoice}
            clientData={clientData}
          />
        );

      default:
        return (
          <RegularTheme1
            invoice={invoice}
            billTitle={billTitle}
            clientData={clientData}
          />
        );
    }
  };


  /* =======================================================
     MAIN JSX
  ======================================================= */

  return (
    <>
      {/* GLOBAL RESPONSIVE CSS */}
      <style>
        {RESPONSIVE_CSS}
      </style>

      <div
        className="invoice-preview-page container-fluid bg-light min-vh-100 py-4"
      >
        <div className="invoice-preview-container">

          {/* =================================================
              HEADER
          ================================================= */}

          <div
            className="d-flex justify-content-between align-items-center mb-4"
            style={{
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                minWidth: 0,
              }}
            >
              <h3 className="fw-bold mb-1">
                Invoice Preview
              </h3>

              <small className="text-muted">
                Invoice No:{" "}
                {invoice.invoiceNo}
              </small>
            </div>

            <button
              className="btn btn-outline-secondary"
              onClick={() =>
                navigate("/home")
              }
            >
              Back
            </button>
          </div>


          {/* =================================================
              FORMAT SELECTOR
          ================================================= */}

          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">

              <h5 className="fw-bold mb-3">
                Select Bill Format
              </h5>

              <div className="row g-2">
                {formats.map(
                  (format) => (
                    <div
                      className="col-12 col-sm-6 col-md-4"
                      key={format.id}
                    >
                      <button
                        type="button"
                        className={`btn w-100 ${
                          billFormat ===
                          format.id
                            ? "btn-dark"
                            : "btn-outline-dark"
                        }`}
                        onClick={() =>
                          setBillFormat(
                            format.id
                          )
                        }
                      >
                        {format.name}
                      </button>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>


          {/* =================================================
              ACTIONS
          ================================================= */}

          <div
            className="d-flex justify-content-end gap-2 mb-3"
            style={{
              flexWrap: "wrap",
            }}
          >
            <button
              className="btn btn-primary"
              onClick={handlePrint}
            >
              Print
            </button>
          </div>


          {/* =================================================
              BILL PREVIEW
          ================================================= */}

          <div
            ref={paperAreaRef}
            className="invoice-preview-paper-area"
          >
            <div
              id="bill-to-print"
              ref={printRef}
              className="invoice-scaled-wrapper"
              style={{
                /*
                  Reserve the scaled visual width.

                  Without this wrapper, CSS transform scales
                  the invoice visually but the layout still
                  occupies its original 210mm width.
                */
                width:
                  selectedFormat.type ===
                  "thermal"
                    ? `${302.36 * paperScale}px`
                    : `${793.70 * paperScale}px`,

                height: "auto",

                flex: "0 0 auto",

                overflow: "visible",

                position: "relative",
              }}
            >
              <div
                style={{
                  width:
                    selectedFormat.type ===
                    "thermal"
                      ? "302.36px"
                      : "793.70px",

                  transform:
                    `scale(${paperScale})`,

                  transformOrigin:
                    "top left",

                  /*
                    Do not let browser flexbox shrink
                    the physical paper.
                  */
                  flex: "0 0 auto",
                }}
              >
                {renderBill()}
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default InvoicePreview;




